import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image'
import { BsCalendarCheck } from 'react-icons/bs';

class FulfillmentPolicy extends Component {
    constructor(props) {
        super(props)
        this.state = {
            
        };
    }

    render() {
        return (
            <div className="container">
                <h1>EZ Live Leads Fulfillment Policy</h1>
                <h3>Refund Policy</h3>
                <p>Customers may receive a refund under the following conditions:</p>
                <ul>
                    <li>A refund will be issued for duplicate or invalid leads that do not meet the agreed-upon criteria.</li>
                    <li>Refund requests must be submitted within <strong>7 days</strong> of receiving the digital web lead.</li>
                    <li>Refunds are issued as account credits or to the original payment method at the company's discretion.</li>
                    <li>To request a refund, customers must contact log into the customer portal at <a href="https://ezmarketing.leadprosper.net">https://ezmarketing.leadprosper.net</a> or email <a href="mailto:support@ezliveleads.com">support@ezliveleads.com</a> with supporting details.</li>
                </ul>
                <h3>Shipping or Delivery Policy</h3>
                <p>EZ Live Leads will deliver all digital web lead forms via:</p>
                <ul>
                    <li><strong>API Integration:</strong> Leads will be delivered directly to your CRM of choice.</li>
                    <li><strong>Email Notification:</strong> An email containing the digital web lead details will be sent to your email address of choice.</li>
                    <li>Delivery of leads begins immediately upon activation of your account, based on the selected package and availability.</li>
                </ul>
                <h3>Return Policy and Process</h3>
                <p>EZ Live Leads allows the return of up to <strong>10%</strong> of purchased digital web leads under the following conditions:</p>
                <ul>
                    <li>Customers must return digital web leads via the <strong>EZ Live Leads Customer Portal:</strong><br />
                    <a href="https://ezmarketing.leadprosper.net">https://ezmarketing.leadprosper.net</a></li>
                    <li>Returns must be made within <strong>7 days</strong> of receiving the lead.</li>
                    <li>Leads must be returned with a valid reason for rejection (e.g., incorrect contact information, duplicate data).</li>
                </ul>
                <h3>Cancellation Policy</h3>
                <p>To pause or cancel the purchase of digital web leads, customers must:</p>
                <ul>
                    <li>Log into the <strong>EZ Live Leads Customer Portal:</strong><br />
                    <a href="https://ezmarketing.leadprosper.net">https://ezmarketing.leadprosper.net</a> and select <strong>"Pause"</strong> leads.</li>
                    <li>To permanently disable an account and request a refund of any remaining balance, customers must email support@ezliveleads.com.</li>
                    <li>Refunds for account balances will be processed within <strong>5-7 business days</strong> after approval.</li>
                </ul>
                <p>For any additional questions or assistance, please contact <a href="mailto:support@ezliveleads.com">support@ezliveleads.com</a>.</p>

            </div>
        );
    }
}
export default FulfillmentPolicy;